import { TransferMajorsSelectedQuery } from './../../queries/transfer_majors_selected_query';
import { TransferMajorsSuggestedQuery } from './../../queries/transfer_majors_suggested_query';
import { TransferConfiguration } from './../../config/transfer_configuration';
import { ICommand } from 'core-ts-types';
import {
  TransferCollegesWithCoursesQuery,
  ITransferCollegeWithCourses
} from './../../queries/transfer_colleges_with_courses_query';
import {
  TransferExamTypeWithExamsQuery,
  ITransferExamTypeWithExams
} from './../../queries/transfer_exam_type_with_exams_query';
import { SitesetupConfiguration } from '../../../sitesetup/config/sitesetup_configuration';

type Mode = 'view' | 'edit';

export class TransferCreditsSummaryController {
  private mode: Mode = 'view';

  constructor(
    private ngTransferCollegesWithCoursesQuery: TransferCollegesWithCoursesQuery,
    private deselectTransferCollegeCommand: ICommand,
    private ngTransferExamTypeWithExamsQuery: TransferExamTypeWithExamsQuery,
    private ngTransferMajorsSuggestedQuery: TransferMajorsSuggestedQuery,
    private ngTransferMajorsSelectedQuery: TransferMajorsSelectedQuery,
    private ngTransferConfiguration: TransferConfiguration,
    private ngSitesetupConfiguration: SitesetupConfiguration
  ) {}

  getTotalCoursesCount(collegeWithCourses: ITransferCollegeWithCourses): number {
    return _.size(collegeWithCourses.courses);
  }

  getReviewedCoursesCount(collegeWithCourses: ITransferCollegeWithCourses): number {
    return _.size(_.filter(collegeWithCourses.courses, (course) => !course.isPending));
  }

  getPendingCourseCount(collegeWithCourses: ITransferCollegeWithCourses): number {
    return this.getTotalCoursesCount(collegeWithCourses) - this.getReviewedCoursesCount(collegeWithCourses);
  }

  getTotalExamCount(examTypeWithExams: ITransferExamTypeWithExams): number {
    return _.size(examTypeWithExams.exams);
  }

  getScoredExamCount(examTypeWithExams: ITransferExamTypeWithExams): number {
    return _.size(_.filter(examTypeWithExams.exams, (exam) => _.isNumber(exam.score)));
  }

  getUnscoredExamCount(examTypeWithExams: ITransferExamTypeWithExams): number {
    return this.getTotalExamCount(examTypeWithExams) - this.getScoredExamCount(examTypeWithExams);
  }

  setMode(mode: Mode) {
    this.mode = mode;
  }

  hasSelectedMajors(): boolean {
    const regularMajors = _.filter(this.ngTransferMajorsSelectedQuery.result.majors, { preprof_ind: false });
    return regularMajors.length > 0;
  }

  hasSelectedCollegeOrExam(): boolean {
    return (
      this.ngTransferCollegesWithCoursesQuery.result.length > 0 ||
      _.some(this.ngTransferExamTypeWithExamsQuery.result, (exam) => {
        return exam.exams.length > 0;
      })
    );
  }

  hasCompletedReview(): boolean {
    return this.hasSelectedMajors() || this.hasSelectedCollegeOrExam();
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferCreditsSummaryController', TransferCreditsSummaryController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/credits_summary/credits_summary.ts